import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globals from '@reusable/services/globals';
import { map } from 'rxjs/operators';

@Injectable()
export class QuickTranslateService {
  constructor(private router: Router, private httpClient: HttpClient, private gtn: globals.GetTokenNow) {}

  translate(body) {
    return this.httpClient.post(`${globals.domain}/core/catalog-parts/translate/`, body, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  listCoreCategories(sort, records, pageNumber, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/categories/list/sortBy-${sort}/${records}/${pageNumber}/`, headers)
      .pipe(map(res => res as any));
  }
  addCorePart(body) {
    return this.httpClient.post(`${globals.domain}/core/parts/add/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
}